import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";
import { pageHref } from "../lib/format";

export default function Breadcrumbs({ items = [] }) {
  if (!items.length) return null;
  return (
    <nav className="flex flex-wrap items-center gap-1 text-xs" data-testid="breadcrumbs">
      <Link to="/" className="flex items-center gap-1 text-[color:var(--nq-stone)] hover:text-[color:var(--nq-gold)]">
        <Home className="h-3.5 w-3.5" /> Home
      </Link>
      {items.map((it, i) => (
        <span key={it.slug || i} className="flex items-center gap-1">
          <ChevronRight className="h-3.5 w-3.5 text-[color:var(--nq-stone)]/60" />
          {i === items.length - 1 ? (
            <span className="font-medium text-[color:var(--nq-gold)]">{it.label}</span>
          ) : (
            <Link to={pageHref(it.slug)} className="text-[color:var(--nq-stone)] hover:text-[color:var(--nq-gold)]">
              {it.label}
            </Link>
          )}
        </span>
      ))}
    </nav>
  );
}
